module.exports = __webpack_public_path__ + "media/images/oval-dashed_line-3c7ee1d15d83c2eca3f46c734fd17c2e.svg";